import React,{ Component } from 'react';
import { FormGroup, Label, FormText} from 'reactstrap';

import 'emoji-mart/css/emoji-mart.css'
import 'react-quill/dist/quill.snow.css';
import './index.css';

import Editor,{ Quill } from 'react-quill';
import { Picker } from 'emoji-mart';

import HiddenInput from '../HiddenInput';

import EmojiSVG from '../../assets/happy.svg';

const LinkFormat = Quill.import('formats/link');

var ToolbarIcons = Quill.import('ui/icons');

const originalSanitize = LinkFormat.sanitize;

LinkFormat.sanitize = function(val){
  let strippedVal = val.replace(/\s+/g, '')

  if (/^\w+:/.test(strippedVal)){

  } else if (!/^https?:/.test(strippedVal)){
    strippedVal = "http://" + strippedVal;
  }
        
  return originalSanitize.call(this, strippedVal); 
}

ToolbarIcons['emoji'] = `<i class='fa fa-smile-o' aria-hidden='true'></i>`;


const REMAINING_CHARACTERS_THRESHOLD = 15;

class RichTextInput extends Component {
  constructor(){
    super();

    this.state = {
      emojiSelectionIndex:0,
      showEmojiPicker:false,
      previousValue:'',
      value:''
    }

    this.quillModules = {
      toolbar:{ 
        container:[['bold', 'italic', 'underline']],
        handlers:{
          emoji:() => this.handleEmojiButtonClick()
        }
      }      
    }
  }

  componentDidMount(){
    if(this.props.defaultValue){
      this.setState({value:this.props.defaultValue});
    }
  }

  handleChange(value){
    const currentLength = value.replace(/<\/?[^>]+(>|$)/g, "").length;

    if(currentLength > this.props.maxLength){
      this.setState({value:this.state.value});
    } else {
      this.setState({
        previousValue:this.state.value,
        value:value,
        currentLength:currentLength
      });
    }
  }

  handleEmojiButtonClick(){
    const selection = this.quill.getEditorSelection();

    this.setState({showEmojiPicker:true});

    if(selection){
      this.setState({emojiSelectionIndex:selection.index});
    }
  }

  handleEmojiSelect(emoji){
    if(emoji){
      const editor = this.quill.getEditor(),
        selection = this.quill.getEditorSelection(),
        emojiSelectionIndex = this.state.emojiSelectionIndex;

      if(emojiSelectionIndex || emojiSelectionIndex === 0){
        editor.insertText(emojiSelectionIndex, emoji.native+' ')
        editor.setSelection(emojiSelectionIndex + 2)
      }
    }

    this.setState({showEmojiPicker:false});
  }

  handlePickerBackdropClick(e){
    e.stopPropagation();
    this.setState({showEmojiPicker:false});
  }

  render(){
    const {
      maxLength,
      label,
      id,
      placeholder,
      name,
      ignoreLengthFeedback,
      showLengthIndicatorAtLength,
      warning
    } = this.props

    const {
      value,
      currentLength,
      showEmojiPicker
    } = this.state;

    const remainingCharacters = maxLength - currentLength;

    return (
      <div id={id} style={{position:'relative'}}>
        <FormGroup>
          <Label>{label}</Label>
          <HiddenInput name={name} value={value} />
          <Editor 
            ref={(el) => this.quill = el}
            modules={this.quillModules}
            value={value}
            onChange={(value) => this.handleChange(value)}
            placeholder={placeholder} 
          />
          {showEmojiPicker && (
            <div>
              <Picker 
                native
                autoFocus
                style={{position:'absolute',top:71,left:116,zIndex:1000}} 
                onSelect={(value) => this.handleEmojiSelect(value)}
                title='Pick an emoji'
              />
              <div               
                style={{position:'fixed',left:0,right:0,top:0,bottom:0,backgroundColor:'transparent',zIndex:999}}
                onClick={(e) => this.handlePickerBackdropClick(e)}
              />
            </div>
          )}
          {warning.length > 0 && (
            <FormText className='DangerFeedback'>{warning}</FormText>
          )}
          {warning.length === 0 && remainingCharacters <= 0 && !ignoreLengthFeedback && (
            <FormText className='FadedFeedback'>Only {maxLength} characters allowed</FormText>
          )}
          {warning.length === 0 && remainingCharacters < showLengthIndicatorAtLength + 1 && remainingCharacters > 0 && !ignoreLengthFeedback && (
            <FormText className='FadedFeedback'>{remainingCharacters} characters remaining</FormText>
          )}
        </FormGroup>
      </div>
    )
  }
}

RichTextInput.defaultProps = {
  warning:'',
  label:'',
  showLengthIndicatorAtLength:REMAINING_CHARACTERS_THRESHOLD,
  maxLength:Number.POSITIVE_INFINITY,
  autoComplete:'off',
  ignoreLengthFeedback:false,
  info:''
}

export default RichTextInput;


// WEBPACK FOOTER //
// ./src/shared/components/RichTextInput/index.js